export const STATUS = {
  nouveau: { label: "Nouveau", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  en_cours: { label: "En cours", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  attente_usager: { label: "En attente d'information", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  resolu: { label: "Résolu", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  clos: { label: "Clôturé", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const CHANNEL = { qr: "QR code", web: "Formulaire public", directory: "Annuaire", user_space: "Espace utilisateur" };

export const AUTHOR_CHANNEL = { compte: "compte VOXA AFRIKA", email: "email", telephone: "téléphone", suivi: "suivi sécurisé (référence + code)" };

export const ABUSE_REASON = {
  spam: "Spam / publicité", propos_injurieux: "Propos injurieux ou haineux", donnees_personnelles: "Données personnelles exposées",
  faux_avis: "Faux avis / usurpation", hors_sujet: "Hors sujet", autre: "Autre motif",
};

export const ABUSE_STATUS = {
  pending: { label: "Signalement en examen", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  upheld: { label: "Signalement retenu", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  dismissed: { label: "Signalement rejeté", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const HISTORY_LABEL = {
  "feedback.create": "Feedback déposé", "feedback.update": "Traitement mis à jour", "feedback.respond": "Message ajouté",
  "feedback.publication.approved": "Avis publié", "feedback.publication.rejected": "Publication refusée",
  "feedback.action.create": "Mesure corrective ajoutée", "feedback.action.update": "Mesure corrective mise à jour",
  "feedback.abuse.report": "Abus signalé par l'organisation", "feedback.abuse.report_public": "Abus signalé par un visiteur",
  "feedback.abuse.upheld": "Modération VOXA AFRIKA : signalement retenu", "feedback.abuse.dismissed": "Modération VOXA AFRIKA : signalement rejeté",
  "feedback.conversation.close": "Conversation fermée", "feedback.conversation.reopen": "Conversation rouverte",
  "feedback.sensitive.on": "Marquée réclamation sensible", "feedback.sensitive.off": "Marquage sensible retiré",
};

export function fmtHours(h) {
  if (h === null || h === undefined) return "—";
  if (h < 1) return `${Math.max(1, Math.round(h * 60))} min`;
  if (h < 48) return `${h.toFixed(1).replace(".0", "")} h`;
  return `${(h / 24).toFixed(1).replace(".0", "")} j`;
}

export const TYPE = {
  avis: { label: "Avis", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  suggestion: { label: "Suggestion", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  reclamation: { label: "Réclamation", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const SENTIMENT = {
  tres_positif: { label: "Très positif", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", color: "#059669" },
  positif: { label: "Positif", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", color: "#34D399" },
  neutre: { label: "Neutre", cls: "bg-slate-100 text-slate-700 border-slate-200", color: "#94A3B8" },
  negatif: { label: "Négatif", cls: "bg-amber-50 text-amber-800 border-amber-200", color: "#D97706" },
  critique: { label: "Critique", cls: "bg-rose-50 text-rose-700 border-rose-200", color: "#E11D48" },
};

export const PRIORITY = {
  basse: { label: "Basse", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  normale: { label: "Normale", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  haute: { label: "Haute", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  critique: { label: "Critique", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const ROLE = { owner: "Administrateur d'entreprise", manager: "Directeur", agency_manager: "Responsable d'agence",
  service_manager: "Responsable de service", agent: "Agent de traitement", report_viewer: "Lecteur de rapports" };

export const CATEGORY = {
  accueil: "Accueil", attente: "Attente", qualite_service: "Qualité du service", disponibilite: "Disponibilité",
  prix: "Prix", proprete: "Propreté", comportement_personnel: "Comportement du personnel", securite: "Sécurité",
  facturation: "Facturation", reclamation: "Réclamation", suggestion: "Suggestion",
};

export const VISIBILITY = {
  public: { label: "Avis public", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  private: { label: "Privé", cls: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const PUBLICATION = {
  pending: { label: "Publication en attente", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  approved: { label: "Publié", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Non publié", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const COMPANY_STATUS = {
  draft: { label: "Brouillon", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  pending: { label: "En attente de validation", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  active: { label: "Active", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  suspended: { label: "Suspendue", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  terminated: { label: "Résiliée", cls: "bg-slate-800 text-white border-slate-800" },
};

export const ORG_TYPE = { prive: "Privé", public: "Public" };

export const SERVICE_TYPE = {
  accueil: "Accueil", caisse: "Caisse", service_client: "Service client", assistance: "Assistance",
  reclamations: "Réclamations", admissions: "Admissions", guichet: "Guichet", autre: "Autre activité",
};

export function fmtDate(iso, withTime = true) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("fr-FR", withTime
    ? { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }
    : { day: "2-digit", month: "short", year: "numeric" });
}
